import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
/**
 * [Model] ShareLink
 */
var ShareLink = /*#__PURE__*/function () {
  function ShareLink() {
    _classCallCheck(this, ShareLink);
  }
  return _createClass(ShareLink, null, [{
    key: "parseV3",
    value:
    /**
     * Parse camel case data from command processor v3 API
     */
    function parseV3(data) {
      var rowData = data || {};
      var link = new ShareLink();
      link.sharedResource = rowData.sharedResource || {};
      link.sharedToken = rowData.sharedToken;
      link.projectName = rowData.projectName;
      link.tokenExpireIn = rowData.tokenExpireIn;
      link.title = rowData.title;
      return link;
    }

    /**
     * Parse camel case data from command processor v2 API
     */
  }, {
    key: "tokenParseV2",
    value: function tokenParseV2(data) {
      var rowData = data || {};
      var link = new ShareLink();
      link.sharedToken = rowData.access_token;
      link.tokenExpireIn = rowData.expires_in;
      return link;
    }
  }]);
}();
export { ShareLink as default };